import globalNav from './global';
import mobileNav from './mobile';
import toolsNav from './tools';

export default function init() {
	globalNav();
	mobileNav();
	toolsNav();
}
